"use strict";
import angular from "angular";
import linkedinGeoTargetingHtmlUrl from "./views/linkedinGeo.list.html";

let app = angular.module("app.linkedinGeoTargeting.component", []);

app.component("linkedinGeoTargeting", {
  bindings: {
    selectedGeoTargeting: "=",
    clusterId: "=",
    showActions: "=",
    isEditForm: "=",
  },
  templateUrl: linkedinGeoTargetingHtmlUrl,
  controller: function ($scope, FormService) {
    let self = this;
    self.geoLocSearch = "";
    self.navLinkedInLocations = [];
    self.selectedCriteria = { criteria: "" };

    self.handleClearSelectedLocations = function () {
      self.selectedGeoTargeting.selLinkedInLocationPickers = [];
      self.selectedCriteria.criteria = "none";
      self.includeOrExcludeLocation = null;
      _.each(self.navLinkedInLocations, function (navLocation) {
        navLocation.criteria = "";
        navLocation.criteria_link = "include";
      });
      $scope.$applyAsync();
    };

    self.searchLinkedInAdsLocation = function (geoLocSearch) {
      if (geoLocSearch.length >= 3) {
        FormService.searchLinkedInAdsLocation(
          self.clusterId,
          geoLocSearch
        ).then(function (success) {
          if (success && success.data.length > 0) {
            self.navLinkedInLocations = success.data.map((item) => ({
              ...item,
              criteria: "",
              criteria_link: "include",
            }));
            $scope.$applyAsync();
          }
        });
      } else if (geoLocSearch.length === 0) {
        self.navLinkedInLocations = [];
        $scope.$applyAsync();
      }
    };

    self.changeIncludeExclude = function (item, criteria) {
      let index = self.navLinkedInLocations.findIndex(
        (loc) => loc.id === item.id
      );
      if (index >= 0) {
        self.navLinkedInLocations[index].criteria = criteria;
        self.navLinkedInLocations[index].criteria_link =
          criteria === "include" ? "included" : "excluded";

        let selIndex =
          self.selectedGeoTargeting.selLinkedInLocationPickers.findIndex(
            (loc) => loc.id === item.id
          );
        if (selIndex >= 0) {
          self.selectedGeoTargeting.selLinkedInLocationPickers[selIndex] =
            self.navLinkedInLocations[index];
        } else {
          self.selectedGeoTargeting.selLinkedInLocationPickers.push(
            self.navLinkedInLocations[index]
          );
        }
        $scope.$applyAsync();
      }
    };

    self.removeLoc = function (item) {
      let selIndex =
        self.selectedGeoTargeting.selLinkedInLocationPickers.findIndex(
          (loc) => loc.id === item.id
        );
      if (selIndex >= 0) {
        self.selectedGeoTargeting.selLinkedInLocationPickers.splice(
          selIndex,
          1
        );
        if (self.selectedGeoTargeting.selLinkedInLocationPickers.length === 0) {
          self.includeOrExcludeLocation = null;
        }
      }

      self.navLinkedInLocations.forEach((loc) => {
        if (loc.name === item.name) {
          loc.criteria = "";
          loc.criteria_link = "include";
        }
      });

      self.previousLocationData = angular.copy(self.navLinkedInLocations);
      $scope.$applyAsync();
    };

    let initLocations = function () {
      if (self.selectedGeoTargeting && !_.isEmpty(self.selectedGeoTargeting)) {
        self.selectedGeoTargeting = JSON.parse(self.selectedGeoTargeting);

        if (self.showActions) {
          self.editMode = true;
          self.enableViewMode = false;
        } else {
          self.editMode = false;
          self.enableViewMode = true;
        }
      } else {
        self.selectedGeoTargeting = {
          selLinkedInLocationPickers: [],
        };

        self.enableViewMode = false;
        self.editMode = false;
      }
    };

    initLocations();
  },
});
